<template>
  <div class="letter">
    <div class="container">
      <div class="content">
        <h1>Dear Marriott Sales Leader,</h1>
        <p>
          Thank you for allowing me to share the story of 500 West Broadway, an
          address which occupies a special place in the rich tapestry of San
          Diego military and civilian history.
        </p>
        <p>
          In 1924 The Armed Services YMCA building opened its doors as a
          recreation center for San Diego service members. Now almost 100 years
          later, this iconic building has been reborn as The Guild Hotel, a
          premier boutique experience in Downtown San Diego. Located in the
          heart of Downtown, the hotel is steps from the legal, financial,
          federal, military and corporate epicenter of San Diego county. The
          historic Gaslamp Quarter, San Diego Bay, and Little Italy are moments
          away by foot, bike, or car.
        </p>
        <p>
          Named “one of the most exciting hotels opening in 2019” by Forbes, and
          a “masterclass in merging old and new” by Vogue Living, The Guild
          Hotel effortlessly reminds us of the past while moving us into the
          future.
        </p>
        <p>
          Please explore the timeline of this cherished building, an overview of
          our features and services, our meeting and event capabilities, and map
          showcasing our ideal location.
        </p>
        <p>
          We look forward to hosting your guests, events, and meetings as we
          continue the tradition of hospitality at this historic address. Please
          contact The Guild sales team or myself if we may assist in your
          efforts.
        </p>
      </div>
      <div class="signature-area">
        <p class="valediction">Yours in Hospitality,</p>
        <div class="signatures">
          <div class="signature">
            <img src="@/assets/home/rick-sig.png" alt="Rick Mansur Signature" />
            <p class="title">
              Rick Mansur <span class="highlight">|</span> President & CEO
            </p>
            <p class="tagline">
              Azul Hospitality Group
            </p>
          </div>
          <div class="signature">
            <img
              src="@/assets/home/steven-sig.png"
              alt="Steven Adyani Signature"
            />
            <p class="title">
              Steven Adyani <span class="highlight">|</span> General Manager
            </p>

            <p class="tagline">The Guild, a Tribute Portfolio Hotel</p>
            <!-- <p>The Guild, a Tribute Portfolio Hotel</p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "letter"
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.letter {
  grid-area: letter;
  padding: 1.5rem;
  z-index: 1;
}

.container {
  background-color: #e7e6e8;
  height: 100%;
  padding: 1rem;
}

.content h1 {
  font: normal 1.5rem $caslon;
  letter-spacing: 0.27px;
  margin-bottom: 0;
}

.content p {
  font: normal 1rem $caslon;
  margin: 0.75rem 0;
}

.signatures {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.signature,
.signature-area {
  text-align: right;
}

.signature:first-of-type {
  margin-right: 2rem;
}

.signature > p {
  font: normal 1rem $caslon;
  letter-spacing: 0;
  margin: 0;
}

.title {
  text-align: right;
  font: normal 1.75rem $caslon;
}

.valediction {
  margin: 0 0 0.25rem 0;
  font: normal 1rem $caslon;
}

.tagline {
  margin: 0;
  font: normal 1rem $caslon;
}

.highlight {
  color: $gold;
}

@media screen and (max-width: 767px) {
  .letter {
    padding: 0;
  }
}

@media screen and (max-width: 545px) {
  .signatures {
    flex-direction: column-reverse;
    align-items: flex-end;
  }

  .signature:first-of-type {
    margin-right: 0;
  }
}
</style>
